<mat-card appearance="outlined" style="position: relative; margin-bottom: 8px"
  [style.margin-left.px]="itemOption.level * 30">
  @for (levelLine of levelLines; track levelLine; let levelLineIndex = $index) {
    @if (levelLineIndex === 0 || levelLineIndex === itemOption.level - 1 || levelLine) {
      <div
      style="
        position: absolute;
        border-left: 2px dashed gray;
        top: 0;
      "
        [style.left.px]="-15 - 30 * (itemOption.level - 1 - levelLineIndex)"
        [style.height]="levelLineIndex === 0 || levelLine ? '100%' : '15px'"
        >
      </div>
    }
    @if (levelLineIndex === itemOption.level - 1) {
      <div
      style="
        position: absolute;
        top: 30px;
        width: 40px;
        padding: 3px 2px;
        z-index: 10;
        font-size: 16px;
        background-color: white;
      "
        [style.left.px]="-20 - 15 - 30 * (itemOption.level - 1 - levelLineIndex)"
        >
      </div>
    }
  }
  <div style="
    position: absolute;
    top: 15px;
    left: -15px;
    width: 15px;
    border-top: 2px dashed gray;
  ">
  </div>
  <mat-card-header>
    <mat-card-title>
      <h3>
        {{ itemOption.name }}
        <app-badge [variant]="getBookableBadgeVariant()" [title]="getBookableBadgeTitle()"></app-badge>
      </h3>
    </mat-card-title>
    @if (!itemOption.showSettings) {
      <mat-card-subtitle>
        <eas-editor-booking-item-option-summary class="subtitle-text" [itemOption]="itemOption"></eas-editor-booking-item-option-summary>
      </mat-card-subtitle>
    }
    <div class="mat-mdc-card-header-actions">
      <ul class="nav justify-content-end">
        <li class="nav-item">
          <button mat-icon-button cdkDragHandle>
            <mat-icon>swap_vert</mat-icon>
          </button>
        </li>
        <li class="nav-item">
          <button mat-icon-button
            [attr.aria-label]="getSettingsButtonTitle()"
            (click)="onToggleShowSettings()">
            <mat-icon>{{ itemOption.showSettings ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </li>
        <li class="nav-item">
          <button mat-icon-button
            aria-label="Edit option"
            i18n-aria-label
            (click)="onEdit()">
            <mat-icon>edit</mat-icon>
          </button>
        </li>
        <li class="nav-item">
          <button mat-icon-button [matMenuTriggerFor]="itemOptionDropdown" aria-label="Show more option actions" i18n-aria-label>
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #itemOptionDropdown="matMenu">
            <button mat-menu-item (click)="onAddChild()" i18n>Add suboption</button>
            <button mat-menu-item (click)="onAddSibling()" i18n>Add sibling option</button>
            <button mat-menu-item (click)="onMoveUp()" i18n>Move up</button>
            <button mat-menu-item (click)="onMoveDown()" i18n>Move down</button>
            <button mat-menu-item (click)="onDuplicate()" i18n>Duplicate</button>
            <button mat-menu-item (click)="onDelete()" i18n>Delete</button>
            <button mat-menu-item (click)="onEditNameList()" i18n>Edit titles</button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-card-header>
  @if (itemOption.showSettings) {
    <mat-card-content>
      <table class="table table-md">
        <colgroup>
        <col style="width: 30%"><col><col>
      </colgroup>
      <tbody eas-editor-booking-item-booking [item]="itemOption"></tbody>
      <tbody eas-editor-booking-item-bundle [item]="itemOption"></tbody>
      @for (itemSetting of itemOption.settings; track itemSetting; let itemSettingIndex = $index) {
        <tbody eas-editor-booking-item-setting
          [item]="itemOption" [itemSetting]="itemSetting" [itemSettingIndex]="itemSettingIndex">
        </tbody>
      }
      <tbody eas-editor-booking-item-metadata-list [item]="itemOption"></tbody>
    </table>
  </mat-card-content>
}
</mat-card>
